<div class="dialog-title">Contact List ({{selected?.length}}/{{leads?.total}})</div>

<div class="dialog-search">
  <mat-icon>search</mat-icon>
  <input type="text" class="form-control" placeholder="Search here ..." name="searchText" autofocus #searchInput
    [(ngModel)]="value"  />
</div>
<div fxLayout="row wrap" class="filtration m-tb-6">

  <div fxFlex>
    <mat-card [matMenuTriggerFor]="status2">
      <mat-list class="responsive-list filter-field">
        <mat-list-item class="item" matRipple>
          <div class="value-f" matLine>
            {{ selectedSalesPerson?.sales_person_name }}
          </div>
          <mat-icon>expand_more</mat-icon>
        </mat-list-item>
      </mat-list>
    </mat-card>
    <mat-menu #status2="matMenu" class="column-radio">
      <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedSalesPerson">
        <mat-radio-button class="value-f" *ngFor="let obj of salesPersonList " [value]="obj"
          (click)="getExistingLeadList(selectedStatus , obj.sales_person_id)">
          {{ obj?.sales_person_name }}
        </mat-radio-button>
      </mat-radio-group>
    </mat-menu>
</div>

  <div fxFlex>
     <mat-card [matMenuTriggerFor]="status">
        <mat-list class="responsive-list filter-field">
          <mat-list-item class="item" matRipple>
            <div class="value-f" matLine>
              {{ selectedStatus }}
            </div>
            <mat-icon>expand_more</mat-icon>
          </mat-list-item>
        </mat-list>
      </mat-card>
      <mat-menu #status="matMenu" class="column-radio">
        <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedStatus">
          <mat-radio-button class="value-f" *ngFor="let obj of LeadStatus | keyvalue: originalOrder" [value]="obj.value"
            (click)="getExistingLeadList(obj.value , selectedSalesPerson?.sales_person_id)">
            <img src="../../../../assets/images/icon/{{ obj?.value }}.svg" style="position: relative; top: 2px" alt="" />
            {{ obj?.value }}
            <div *ngIf="obj?.value == 'All Leads Status'" class="objValue">({{ leads?.total ? (leads?.total | number) : 0 }})</div>
            <div *ngIf="obj?.value == 'Open'" class="objValue">({{ leads?.openTotal ? (leads?.openTotal | number) : 0}})</div>
            <div *ngIf="obj?.value == 'Waiting List'" class="objValue">({{ leads?.waitingListTotal ?(leads?.waitingListTotal | number) : 0 }})</div>
            <div *ngIf="obj?.value == 'Hot'" class="objValue">({{ leads?.hotTotal ? (leads?.hotTotal | number) : 0 }})</div>
            <div *ngIf="obj?.value == 'Cold'" class="objValue">({{ leads?.coldTotal ? (leads?.coldTotal | number) : 0}})</div>
            <div *ngIf="obj?.value == 'Converted'" class="objValue">({{ leads?.signTotal + leads?.soldTotal + leads?.reservedTotal | number }})</div>
            <div *ngIf="obj?.value == 'Dropped'" class="objValue">({{ leads?.dropTotal ? (leads?.dropTotal | number) : 0
              }})</div>
          </mat-radio-button>
        </mat-radio-group>
      </mat-menu>
      </div>

</div>
<div class="m-b-10">
  <mat-checkbox  class="example-margin" *ngIf= "contactList" [(ngModel)]="isChecked" (change)="selectAll($event)">
    <div class="xsTitle-f" matLine>Select All</div>
  </mat-checkbox>
</div>


<div id="scrollArea" class="scroll-dialog-content core-list">
  <mat-selection-list [(ngModel)]="selected">
    <mat-list-option *ngFor="let lead of leadList | SearchFilter: value; ; let i=index" checkboxPosition="before"
      [disableRipple]="true" click-stop-propagation [value]="lead">
      <div fxLayout="row wrap" *ngIf="i+1 === leadList.length" #theLast>
        <div fxFlex matLine>
          <div fxLayout="wrap" >
         <section fxFlex="50" (click)="contentDialog(lead?.contact_id)" class="xsTitle-f " style="text-align: left!important"><u><b>{{lead?.full_name}}</b></u></section> 
           <section fxFlex="50" (click)="contentDialog(null , lead?.sales_person_id)" class="xsTitle-f "style="text-align: right !important;" ><u><b>{{lead?.sales_person_name}}</b></u></section> 
        </div>
          <div class="contact-row" mat-line>
            <span class="icon-text">
              <mat-icon class="indicator-12">stay_current_portrait</mat-icon>
              <span class="download-link fs-10">{{lead?.phone_no}}</span>
            </span>
            <span class="vertical-divider desc-f"> | </span>
            <span class="icon-text">
              <mat-icon class="indicator-12">email</mat-icon>
              <span class="download-link fs-10">{{lead?.email}}</span>
            </span>
          </div>
        </div>
      </div>
      <div fxLayout="row wrap" *ngIf="i+1 != leadList.length">
        <div fxFlex matLine>
          <div fxLayout="wrap" >
         <section fxFlex="50" (click)="contentDialog(lead?.contact_id)" class="xsTitle-f " style="text-align: left!important"><u><b>{{lead?.full_name}}</b></u></section> 
           <section fxFlex="50" (click)="contentDialog(null , lead?.sales_person_id)" class="xsTitle-f "style="text-align: right !important;" ><u><b>{{lead?.sales_person_name}}</b></u></section> 
        </div>
          <div class="contact-row" mat-line>
            <span class="icon-text">
              <mat-icon class="indicator-12">stay_current_portrait</mat-icon>
              <span class="download-link fs-10">{{lead?.phone_no}}</span>
            </span>
            <span class="vertical-divider desc-f"> | </span>
            <span class="icon-text">
              <mat-icon class="indicator-12">email</mat-icon>
              <span class="download-link fs-10">{{lead?.email}}</span>
            </span>
          </div>
        </div>
      </div>
    </mat-list-option>
  </mat-selection-list>
</div>

<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" [mat-dialog-close]="false" (click)=submit()>Select</button>
</div>